'use client';
import { LicenseInfo } from '@mui/x-license';

LicenseInfo.setLicenseKey(
  '024c71d72f10d624b11217bc63581d36Tz0xMjYzNzIsRT0xODA0MTE4Mzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI='
);

export default function MuiXLicense() {
  return null;
}
